import React, { useState } from "react";
import Layout from "../../../components/Layouts/Layouts/Layout";
import Layout2 from "../../../components/Layouts/Layouts/Layout2";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Pagination from "react-bootstrap/Pagination";
import QuickLinks from "../../../components/basic/QuickLinks";

const agreements = [
  {
    srNo: 1,
    agreementId: "A23-24001",
    title:
      "M/s. Samson Scientifics and Surgicals Pvt. Ltd. and M/s. Fahad Abdul Rauof Batterjee Co. Ltd. (Distribution Agency Agreement)",
    version: "1'-23",
    printId: "AECCI-4234/23",
    matterNumber: "--",
    industry: "Pharmaceutical products",
    operativeDate: "6th July, 2020",
    expiryDate: "--",
    country: "--",
  },
  {
    srNo: 2,
    agreementId: "A23-24002",
    title:
      "M/s. Sirmaxo Chemicals Pvt. Ltd. and M/s. Egyptian German Company (Agency Contract)",
    version: "1-23",
    printId: "AECCI-1381/23",
    matterNumber: "--",
    industry: "Pharmaceutical & Health care products",
    operativeDate: "The validity of contract is 3 years",
    expiryDate: "--",
    country: "--",
  },
  {
    srNo: 3,
    agreementId: "A23-24003",
    title:
      "M/s. Sirmaxo Chemicals Pvt. Ltd. and M/s. Egyptian German Company (Agent Agreement)",
    version: "1-23",
    printId: "AECCI-1382/23",
    matterNumber: "--",
    industry: "Pharmaceutical & Health care products",
    operativeDate: "13th December, 2021",
    expiryDate: "12th December, 2024",
    country: "--",
  },
  {
    srNo: 4,
    agreementId: "A23-24004",
    title: "M/s. Daxal Cosmetics Pvt. Ltd. and M/s. ISW Vendors SRL",
    version: "1-23",
    printId: "AECCI-2021/23",
    matterNumber: "--",
    industry: "Cosmetic products",
    operativeDate: "8th March, 2023",
    expiryDate: "7th March, 2033",
    country: "--",
  },
  {
    srNo: 5,
    agreementId: "A23-24005",
    title:
      "M/s. Geetanjali Woollens Pvt. Ltd. and Mr. Abraham Gebrekirstos GebreMedhin (General POA)",
    version: "1-23",
    printId: "AECCI-1056/23",
    matterNumber: "--",
    industry: "Woollen / Textile",
    operativeDate: "29th April, 2023",
    expiryDate: "Lifetime",
    country: "--",
  },
  {
    srNo: 6,
    agreementId: "A23-24006",
    title:
      "M/s. S V International Holdings Ltd. and Mr. Abraham Gebrekirstos GebreMedhin (General POA)",
    version: "1-23",
    printId: "AECCI-1057/23",
    matterNumber: "--",
    industry: "Stocks, Share, Annuities & Finance",
    operativeDate: "29th April, 2023",
    expiryDate: "Lifetime",
    country: "--",
  },
  {
    srNo: 7,
    agreementId: "A23-24007",
    title: "M/s. Aai Maa Khodiyar Industries and M/s. Yizang Trading Co. Ltd.",
    version: "1-23",
    printId: "AECCI-1381/23",
    matterNumber: "--",
    industry: "Crops",
    operativeDate: "04th May, 2023",
    expiryDate: "03rd May, 2026",
    country: "--",
  },
  {
    srNo: 8,
    agreementId: "A23-24008",
    title:
      "M/s. Aruhi Life Sciences Private Limited and M/s. Aster Orion Pharma for Import (Agent Agreement)",
    version: "1-23",
    printId: "AECCI-1381/23",
    matterNumber: "--",
    industry: "Pharmaceutical products",
    operativeDate: "03rd December, 2023",
    expiryDate: "2nd December, 2026",
    country: "--",
  },
  {
    srNo: 9,
    agreementId: "A24-25009",
    title:
      "M/s. Ridhi Steel and Tube Ltd Vs. M/s. Mega Steel Co.(Contract for Sale)",
    country: "Qatar",
    version: "1-24",
    printId: "AECCI-1382/24",
    matterNumber: "--",
    industry: "715 MT Mild Steel Galvanized Pipes",
    operativeDate: "--",
    expiryDate: "5 years",
  },
  {
    srNo: 10,
    agreementId: "A24-25010",
    title:
      "Exclusive Agency Agreement between Dynamic Products Limited, India and M/s. Keyhan Tejarat Paras Pasargad, Iran",
    version: "1-24",
    printId: "AECCI-1383/24",
    matterNumber: "--",
    industry: "manufacturer of colors for the textile industry",
    operativeDate: "1st January 2024",
    expiryDate: "1st January 2026",
    country: "Iran",
  },
  {
    srNo: 11,
    agreementId: "A24-25011",
    title: "Cyrus Todiwala Medical Vs Jira, Health Centre",
    country: "Nigeria",
    version: "1-24",
    printId: "AECCI-1384/24",
    matterNumber: "--",
    industry: "Pharmaceutical Product(SANITOL)",
    operativeDate: "--",
    expiryDate: "--",
  },
  {
    srNo: 12,
    agreementId: "A24-25012",
    title:
      "M/s. Laxmichand Dayabhai Co. Pvt. Ltd and M/s. Saril Agital (Contract)",
    country: "Algeria",
    version: "1-24",
    printId: "AECCI-1385/24",
    matterNumber: "--",
    industry: "Indian Parboiled rice",
    operativeDate: "--",
    expiryDate: "5 Years",
  },
  {
    srNo: 13,
    agreementId: "A24-25013",
    title:
      "Distribution Agreement between Nebula Surgical Pvt. Ltd. India and Distribuidora Medica, Gautemala",
    version: "1-24",
    printId: "AECCI-1386/24",
    matterNumber: "--",
    industry: "Orthopedic",
    operativeDate: "5th January 2024",
    expiryDate: "5th January 2025",
    country: "Gautemala",
  },
  {
    srNo: 14,
    agreementId: "A24-25015",
    title:
      "Agreement Between Vecta Biotech Private Limited, India and Alandalus Drugs, Sudan",
    version: "1-24",
    printId: "AECCI-1068/24",
    matterNumber: "--",
    industry: "Herbals, Cosmetics, Nutraceutic, Pharmaceticals",
    operativeDate: "5th February 2024",
    expiryDate:
      "5th February 2026 and valid period is over then Automatically Renewable for 3 years",
    country: "Sudan",
  },
  {
    srNo: 15,
    agreementId: "A24-25016",
    title:
      "Agency Distribution Agreement between Resonant Pharmaceuticals Pvt. Ltd., India And Al- Saggaf Medical & Pharmaceutical Imports, Yeman",
    version: "1-24",
    printId: "AECCI-1069/24",
    matterNumber: "--",
    industry: "Pharmacetical",
    operativeDate: "7th March 2024",
    expiryDate:
      "7th March 2024 to 5 years after that valid period then it automatically renewed to 5 years. Automatically Renewable for 5 years",
    country: "Yemen",
  },
  {
    srNo: 16,
    agreementId: "A24-25014",
    title: "M/s. Geolife Agri Tech India Pvt. Ltd and M/s. Eco Agro Science",
    country: "Egypt",
    version: "1-24",
    printId: "AECCI-1387/24",
    matterNumber: "--",
    industry: "Eco Nema",
    operativeDate: "22nd April 2024",
    expiryDate: "21st April 2023",
  },
  {
    srNo: 17,
    agreementId: "A24-25017",
    title: "NUTRA HEALTHCARE Vs. Al-Attar International Holding Cyrus",
    country: "Iraq",
    version: "1-24",
    printId: "AECCI-1068/24",
    matterNumber: "--",
    industry: "Electrical Gauge",
    operativeDate: "--",
    expiryDate: "--",
  },
  {
    srNo: 18,
    agreementId: "A24-25018",
    title:
      "Agreement for Authorised representative services between HiMedia Laboratories Prvt Ltd., India and Al Osool Medical Trading Co. Riyadh",
    version: "1-24",
    printId: "AECCI-1067/24",
    matterNumber: "--",
    industry: "Manufacturing Medical devices",
    operativeDate: "23rd April 2024",
    expiryDate: "valid for 5 years",
    country: "India and Saudi Arabia",
  },
  {
    srNo: 19,
    agreementId: "A24-25019",
    title: "Astrophoton Vs Skylights Enterprise.",
    country: "ESTONIA",
    version: "1-24",
    printId: "AECCI-1061/24",
    matterNumber: "--",
    industry: "Automatic Voltage Stabilizers",
    operativeDate: "--",
    expiryDate: "--",
  },
  {
    srNo: 20,
    agreementId: "A24-25020",
    title:
      "Market Authorisation and Representation Agreement between M. B. Sugars & Phramceuticals Pvt.Ltd,India and Grencross Export Pvt. Ltd,India",
    version: "1-24",
    printId: "AECCI-1066/24",
    matterNumber: "--",
    industry: "Product design, Manufacturing, Technology etc",
    operativeDate: "08th May 2024",
    expiryDate: "2nd February 2028",
    country: "Russia, Belarus, Uzbekistan, Kazakhastan, Ukraine and Azerbaijan",
  },
  {
    srNo: 21,
    agreementId: "A24-25021",
    title: "M/s. Komppitent Group LLC and M/s. Vimo Foods Pvt Ltd",
    country: "Moscow",
    version: "1-24",
    printId: "AECCI-1067/24",
    matterNumber: "--",
    industry: "--",
    operativeDate: "11th May 2024",
    expiryDate: "5 years",
  },
  {
    srNo: 22,
    agreementId: "A24-25022",
    title: "NUTRA HEALTHCARE Vs. Al-Attar International Holding",
    country: "Iraq",
    version: "1-24",
    printId: "AECCI-1068/24",
    matterNumber: "--",
    industry: "Electrical Gauge",
    operativeDate: "16th May 2024",
    expiryDate: "Lifetime",
  },
  {
    srNo: 23,
    agreementId: "A24-25023",
    title: "RALLIS AGROTECH INDIA Vs. Albadia Agrotech",
    country: "YEMEN",
    version: "1-24",
    printId: "AECCI-1064/24",
    matterNumber: "--",
    industry: "Agrochemicals",
    operativeDate: "--",
    expiryDate: "Lifetime",
  },
  {
    srNo: 24,
    agreementId: "A24-25024",
    title:
      "INDUSTRAIL SOLVENTS PVT LTD(India) between ANATOLIA FACILITATORS(Turkey)",
    version: "1-24",
    printId: "AECCI-1086/24",
    matterNumber: "--",
    industry: "Petrochemical",
    operativeDate: "01st March 2024",
    expiryDate: "--",
    country: "Turkey",
  },
  {
    srNo: 25,
    agreementId: "A24-25025",
    title:
      "INDUSTRAIL SOLVENTS PVT LTD(India) between Albadia Solutions (Egypt)",
    version: "1-24",
    printId: "AECCI-1087/24",
    matterNumber: "--",
    industry: "Petrochemical",
    operativeDate: "01st March 2024",
    expiryDate: "--",
    country: "Egypt",
  },
  {
    srNo: 26,
    agreementId: "A24-25024",
    title: "M/s. Komppitent Group LLC and M/s. Vimo Foods Pvt Ltd",
    country: "Moscow",
    version: "1-24",
    printId: "AECCI-1063/24",
    matterNumber: "--",
    industry: "--",
    operativeDate: "03rd June 2024",
    expiryDate: "5 years",
  },
  {
    srNo: 27,
    agreementId: "A25-26026",
    title:
      "Triparty Agreement between Zenon Life Sciences Pvt. Ltd, India and Lative Life Sciences Pvt. Ltd, India and Medinova Pharmatical Inc. Philippines",
    version: "1-25",
    printId: "AECCI-1029/25",
    matterNumber: "--",
    industry: "Pharmacetical",
    operativeDate: "9th June 2024",
    expiryDate: "9th January 2028(Valid for 5years)",
    country: "Philippines",
  },
  {
    srNo: 28,
    agreementId: "A25-26027",
    title:
      "Exclusive Market Authorisation & Exclusive Representation Agreement between Rajat Vinyls Pvt Ltd. India and Greencross Export Pvt. Ltd",
    version: "1-25",
    printId: "AECCI-1028/27",
    matterNumber: "--",
    industry: "Pharmacetical",
    operativeDate: "14th August 2024",
    expiryDate: "14th February 2034(valid for 10 years)",
    country: "Russia, Belarus, Uzbekistan, Kazakhastan, Ukraine",
  },
  {
    srNo: 29,
    agreementId: "A25-26022",
    title: "Agrochem India Pvt Ltd. Vs. Jordan Agritech Pvt Ltd",
    country: "JORDAN",
    version: "1-24",
    printId: "AECCI-1026/24",
    matterNumber: "--",
    industry: "Agrochemicals",
    operativeDate: "08th September 2024",
    expiryDate: "Lifetime",
  },
  {
    srNo: 30,
    agreementId: "A25-26029",
    title:
      "Customer Protection Agreement between Greenross Export Pvt Ltd.India and Sigachi Industries, India",
    version: "1-24",
    printId: "AECCI-1023/24",
    matterNumber: "--",
    industry: "Pharmacetical",
    operativeDate: "10th September 2024",
    expiryDate:
      "Valid for 3 years and after the period it shall be automatically renewed (10th March 2026)",
    country: "NA",
  },
  {
    srNo: 31,
    agreementId: "A25-26030",
    title:
      "contract manufacturing agreement between indian scientific glass industries and samarpit group",
    version: "1-24",
    printId: "AECCI-1043/24",
    matterNumber: "--",
    industry: "manufacture glass products",
    operativeDate: "3rd October 2024",
    expiryDate: "minimum 10 years",
    country: "Russia",
  },
  {
    srNo: 32,
    agreementId: "A25-26031",
    title:
      "loan license agreement between dinesh remedies limited and samarpit group",
    version: "1-24",
    printId: "AECCI-1060/24",
    matterNumber: "--",
    industry: "Pharmacetical",
    operativeDate: "17th November 2024",
    expiryDate: "Non-ending agreement",
    country: "Russia",
  },
  {
    srNo: 33,
    agreementId: "A25-26032",
    title:
      "M/s. Shivam Agro Process Pvt Ltd Vs. M/s. Pyratrade Pvt. Ltd.(Contract for Sale)",
    country: "South Africa",
    version: "1-24",
    printId: "AECCI-1039/24",
    matterNumber: "--",
    industry: "Indian First Special Grade Castor Oil",
    operativeDate: "28th November 2024",
    expiryDate: "Lifetime",
  },
  {
    srNo: 34,
    agreementId: "A25-26033",
    title: "M/s. Komppitent Group LLC and M/s. Vimo Foods Pvt Ltd",
    country: "Moscow",
    version: "1-25",
    printId: "AECCI-1040/25",
    matterNumber: "--",
    industry: "--",
    operativeDate: "08th January 2025",
    expiryDate: "5 years",
  },
  {
    srNo: 35,
    agreementId: "A25-26034",
    title: "M/s. Geolife Agri Tech India Pvt. Ltd and M/s. Eco Agro Science",
    country: "Egypt",
    version: "1-25",
    printId: "AECCI-1026/25",
    matterNumber: "--",
    industry: "Eco Nema",
    operativeDate: "22nd April 2025",
    expiryDate: "21st April 2030",
  },
  {
    srNo: 36,
    agreementId: "A24-25009",
    title:
      "M/s. Hexaware Technologies Limited and Mr. Ahmed Fouad El-Watan Amin, Mr. Mohamed Ahemed Fouad El-Watan, Mr. Wael Nabil Fahmy Emam, Mr. taher Adel Napoleon Abdel Latif",
    country: "--",
    version: "25-jan",
    printId: "AECCI-11066/25",
    matterNumber: "--",
    industry:
      "All matters related to the incorporation and establishment of the companies in the Arab Republic of Egypt",
    operativeDate: "09th January 2025",
    expiryDate: "Expire immediately after the fulfillment of the purpose",
  },
  {
    srNo: 37,
    agreementId: "A26-27010",
    title:
      "M/s. Spice Nest Impex Private Limited and Golden Rakes Grocery Company.",
    country: "--",
    version: "26-jan",
    printId: "AECCI-1529/26",
    matterNumber: "--",
    industry: "Spices and Spices Powders",
    operativeDate: "10th January 2025",
    expiryDate: "03 Years - 14.01.2029",
  },
];

const ListOfAgreement = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const rowsPerPage = 5;

  // Filter agreements based on search query
  const filteredAgreements = agreements.filter(
    (agreement) =>
      (agreement.title &&
        agreement.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (agreement.agreementId &&
        agreement.agreementId
          .toLowerCase()
          .includes(searchQuery.toLowerCase())),
  );

  // Calculate the number of pages based on filtered agreements
  const totalPages = Math.ceil(filteredAgreements.length / rowsPerPage);

  // Get the current rows to display
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredAgreements.slice(indexOfFirstRow, indexOfLastRow);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  // Generate pagination items
  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => handlePageChange(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  return (
    <Layout>
      <Layout2>
        <DashboardHeader />
        <Container className="py-4">
          <Row>
            <Col>
              <h4 className="mb-3">
                List of Agreements with AECCI-IAC Modal clause
              </h4>
              <hr />
              <div className="text-secondary fw-bold">From 1st April 2023</div>
              <span>Report generated on 13-08-2024</span>
            </Col>
          </Row>
          <Row className="my-2">
            <Col md={6}>
              <Form.Group controlId="searchAgreements">
                <Form.Control
                  type="text"
                  placeholder="Search by Agreement Title or ID"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="table-responsive">
                <Table
                  striped
                  bordered
                  hover
                  className="mt-4"
                  style={{ minWidth: "1200px" }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center">Sr No.</th>
                      <th className="text-center">Agreement ID</th>
                      <th className="text-center">Agreement Title</th>
                      <th className="text-center">Version</th>
                      <th className="text-center">Print ID</th>
                      <th className="text-center">Matter Number</th>
                      <th className="text-center">Industry</th>
                      <th className="text-center">Country</th>
                      <th className="text-center">Operative Date</th>
                      <th className="text-center">Expiry Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.length > 0 ? (
                      currentRows.map((agreement) => (
                        <tr key={agreement.srNo}>
                          <td className="text-center">{agreement.srNo}</td>
                          <td className="text-center">
                            {agreement.agreementId || "--"}
                          </td>
                          <td>{agreement.title}</td>
                          <td className="text-center">
                            {agreement.version || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.printId || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.matterNumber || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.industry || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.country || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.operativeDate || "--"}
                          </td>
                          <td className="text-center">
                            {agreement.expiryDate || "--"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No agreements found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              <div className="d-flex justify-content-center mt-3">
                <Pagination>
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {paginationItems}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            </Col>
          </Row>
        </Container>
        <QuickLinks />
      </Layout2>
    </Layout>
  );
};

export default ListOfAgreement;
